var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreaterSign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 11,
    viewBox: "0 0 7 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.993233 0.814408L5.56073 5.50003L0.993233 10.1857C0.911462 10.2694 0.865684 10.3818 0.865684 10.4988C0.865684 10.6158 0.911462 10.7282 0.993233 10.8119C1.03295 10.8524 1.08035 10.8846 1.13267 10.9066C1.18499 10.9286 1.24117 10.9399 1.29792 10.9399C1.35467 10.9399 1.41085 10.9286 1.46317 10.9066C1.51549 10.8846 1.56289 10.8524 1.60261 10.8119L6.4626 5.82722C6.54793 5.73968 6.59568 5.62228 6.59568 5.50003C6.59568 5.37779 6.54793 5.26038 6.4626 5.17285L1.60355 0.188158C1.5638 0.147336 1.51628 0.11489 1.46379 0.0927353C1.41129 0.0705814 1.3549 0.0591679 1.29792 0.0591679C1.24095 0.0591679 1.18455 0.0705814 1.13205 0.0927353C1.07956 0.11489 1.03204 0.147336 0.992295 0.188158C0.910525 0.271874 0.864746 0.384258 0.864746 0.501284C0.864746 0.618309 0.910525 0.730692 0.992295 0.814408L0.993233 0.814408Z",
    fill: "#373737"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreaterSign);
export default __webpack_public_path__ + "static/media/greaterSign.9e22dbaaaa8021aa1796f4e991ee58d4.svg";
export { ForwardRef as ReactComponent };